export default __webpack_public_path__ + "static/media/bookmark-fill.17264930.svg";